<template>
  <div class="list-wrap">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <div class="list-name">
          <div>
            用户：{{ $$(item, ['userInfo', 'userInfo', 'profile', 'realName'], item.who) }}（{{ item.areaName }}）
            <span class="red" v-show="item.isIgnore">【已看过别人】</span>
          </div>
        </div>
        <div class="list-flex">
          <div class="list-flex-left">
            <div>阅读：{{ item.isIgnore ? '+0' : '+1' }}</div>
            <div>点击：+{{ item.numVisit }}</div>
          </div>
          <div>
            <div>首次点击：{{ dayjs(item.createTime).format('YYYY-MM-DD HH:mm') }}</div>
            <div>末次点击：{{ dayjs(item.updateTime).format('YYYY-MM-DD HH:mm') }}</div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import Vue from 'vue';
import { List } from 'vant';
import { sourceDetailList } from '@/api/cms';

Vue.use(List);
export default {
  name: 'cms-detail-list',
  data() {
    return {
      dayjs,
      acc: '',
      list: [],
      page: 0,
      loading: false,
      finished: false
    };
  },
  beforeMount() {
    this.acc = this.$route.query.acc;
  },
  methods: {
    async onLoad() {
      const d = await this.getList(this.page);
      this.loading = false;
      const { data, meta } = d.data.pub.source.historyList;
      this.page++;
      this.list = this.list.concat(data);
      if (this.list.length >= meta.count) {
        this.finished = true;
      }
    },
    to(path) {
      this.$router.push({ path });
    },
    getList(page = 0) {
      const params = {
        acc: this.acc,
        query: {
          page,
          limit: 10
        }
      };
      return sourceDetailList(params);
    }
  }
};
</script>

<style scoped lang="less">
.list-wrap {
  background: #f5f5f5;
  padding: 15px;
}
.row-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list-item {
  background-color: #fff;
  margin-bottom: 15px;
  padding: 10px;
  display: flex;
  border-radius: 4px;
  font-size: 14px;
  color: #555;
  flex-direction: column;
  .list-name {
    font-size: 15px;
    color: #333;
    font-weight: bold;
    margin-bottom: 8px;
    .red {
      color: red;
    }
  }
  .list-flex {
    display: flex;
    line-height: 1.5;
  }
  .list-flex-left {
    flex: 1;
  }
}
</style>
